// Shared look for row action popovers (MUI <Menu>), taken from the Orders table "more" menu.
// Usage: <Menu PaperProps={menuPaperProps} MenuListProps={menuListProps} ...><MenuItem style={menuItemStyle}>
export const menuPaperProps = {
  style: {
    borderRadius: 8,
    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    border: "1px solid #e2e8f0",
    minWidth: 200,
    padding: 0,
  },
};

export const menuListProps = { style: { padding: 0 } };

export const menuItemStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: 12,
  minHeight: 32,
  color: "#374151",
  padding: "5px 12px",
};
